<template>
  <div>
    <p v-if="!isEditable">
      {{ value.name }}
    </p>
    <div
      v-if="isEditable"
      class="beneficiary-form"
    >
      <div class="delete-this-beneficiary-wrapper">
        <img
          src="/img/grayX.svg"
          height="26"
          width="26"
          class="delete-this-beneficiary"
          title="delete this beneficiary"
          @click="deleteThisBeneficiary"
        >
      </div>
      <div>
        <input-field
          :value="beneficiary.name"
          :editable="true"
          @input="updateName"
        >
          Name *
        </input-field>
      </div>
      <div>
        <input-field
          :value="beneficiary.street"
          :editable="true"
          @input="updateStreet"
        >
          Street Address
        </input-field>
      </div>
      <div>
        <input-field
          :value="beneficiary.cityStateZip"
          :editable="true"
          @input="updateCityStateZip"
        >
          City, State, Zip
        </input-field>
      </div>
      <div>
        <date-field
          :value="beneficiary.dateOfBirth"
          :editable="true"
          @input="updateDateOfBirth"
        >
          Date of Birth *
        </date-field>
      </div>
      <div>
        <input-field
          :value="beneficiary.relationship"
          :editable="true"
          @input="updateRelationship"
        >
          Relationship *
        </input-field>
      </div>
      <div>
        <input-field
          :value="beneficiary.percentage"
          :editable="true"
          type="number"
          @input="updatePercentage"
        >
          Percentage *
        </input-field>
      </div>
    </div>
  </div>
</template>

<script>
import InputField from "@/components/elements/InputField";
import DateField from "@/components/elements/DateField";
export default {
	name: "BeneficiaryForm",
	components:{
		InputField,
		DateField
	},
	props:{
		value: {
			type: Object,
			default: function(){
				return {
					name:"",
					street:"",
					cityStateZip:"",
					dateOfBirth:"",
					relationship:"",
					percentage:""
				}
			}
		},
		isEditable: {
			type: Boolean,
			default: false
		}
	},
	emits: ['deleted'],
	data() {
		return {
			beneficiary: {
				name: '',
				street: '',
				cityStateZip: '',
				dateOfBirth: '',
				relationship: '',
				percentage: ''
			}
		}
	},
	mounted() {
		this.beneficiary.name = this.value.name;
		this.beneficiary.street = this.value.street;
		this.beneficiary.cityStateZip = this.value.cityStateZip;
		this.beneficiary.dateOfBirth = this.value.dateOfBirth;
		this.beneficiary.relationship = this.value.relationship;
		this.beneficiary.percentage = this.value.percentage;
	},
	methods: {
		updateName(newValue){
			if (typeof newValue === 'string') {
				this.beneficiary.name = newValue;
				this.updateThisBeneficiary();
			}
		},
		updateStreet(newValue){
			if (typeof newValue === 'string') {
				this.beneficiary.street = newValue;
				this.updateThisBeneficiary();
			}
		},
		updateCityStateZip(newValue){
			if (typeof newValue === 'string') {
				this.beneficiary.cityStateZip = newValue;
				this.updateThisBeneficiary();
			}
		},
		updateDateOfBirth(newValue){
			if (typeof newValue === 'string') {
				this.beneficiary.dateOfBirth = newValue;
				this.updateThisBeneficiary();
			}
		},
		updateRelationship(newValue){
			if (typeof newValue === 'string') {
				this.beneficiary.relationship = newValue;
				this.updateThisBeneficiary();
			}
		},
		updatePercentage(newValue){
			if (typeof newValue === 'string') {
				this.beneficiary.percentage = newValue;
				this.updateThisBeneficiary();
			}
		},
		updateThisBeneficiary(){
			this.$emit('updated', this.beneficiary);
		},
		deleteThisBeneficiary(){
			this.$emit('deleted');
		}
	}
}
</script>
<style lang="scss" scoped>
@use "../../scss/_variables.scss";

.beneficiary-form{
	border-bottom: thin solid variables.$color-divider;
	margin-bottom: 15px;
	padding-bottom: 15px;
}
.delete-this-beneficiary-wrapper{
	margin-bottom: 10px;
	text-align: right;
}
.delete-this-beneficiary{
	cursor: pointer;
}
</style>
